// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type * as React from "react";

/**
 * Focal Systems logo mark.
 * Fully Lucide-compatible (accepts all SVG props, inherits currentColor).
 */
export function FocalLogoIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0637 1.66016C9.49503 1.66016 9.0041 2.05936 8.88697 2.61703L8.11304 6.30175H3.45883C2.89016 6.30175 2.39922 6.70095 2.28209 7.25862L0.104919 17.6243C-0.524352 20.6203 1.75672 23.4375 4.81188 23.4375H14.9363C15.505 23.4375 15.9959 23.0383 16.113 22.4806L16.887 18.7959H21.5412C22.1098 18.7959 22.6008 18.3967 22.7179 17.839L24.8951 7.47333C25.5244 4.47732 23.2433 1.66016 20.1881 1.66016H10.0637ZM16.887 18.7959L19.1042 8.23947C19.314 7.2408 18.5536 6.30175 17.5352 6.30175H8.11304L5.89581 16.8582C5.68605 17.8569 6.44641 18.7959 7.46479 18.7959H16.887Z"
        fill="currentColor"
      />
      <path
        d="M16.6333 12.5615C16.6333 14.8494 14.7826 16.704 12.4997 16.704C10.2167 16.704 8.36599 14.8494 8.36599 12.5615C8.36599 10.2737 10.2167 8.41906 12.4997 8.41906C14.7826 8.41906 16.6333 10.2737 16.6333 12.5615Z"
        fill="currentColor"
      />
    </svg>
  );
}
